export const LITE_COURSE_LABEL = 'Lite'
export const CLASIC_COURSE_LABEL = 'Classic'
export const COMPLETE_COURSE_LABEL = 'Complete'
export const PREMIUM_COURSE_LABEL = 'Premium'
